import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { paths } from 'src/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

import { bgGradient, textGradient } from 'src/theme/css';

import Iconify from 'src/components/iconify';
import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeForDesigner() {
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  const renderDescription = (
    <Box
      sx={{
        textAlign: { xs: 'center', md: 'left' },
        mt: 10,
        maxWidth: 520,
        mx: { xs: 'auto', md: 0 },
      }}
    >
      <m.div variants={varFade().inUp}>
        <Typography component="div" variant="overline" sx={{ color: 'primary.main', mb: 1 }}>
          Let’s Collaborate
        </Typography>

        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          I enjoy working on meaningful products, scalable systems, and ideas that challenge how the
          web is built. If you’re looking to collaborate, discuss architecture, or build something
          impactful, I’m always open to a conversation.
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Typography
          variant="h2"
          sx={{
            mt: 4,
            mb: 5,
            ...textGradient(
              `300deg, ${theme.palette.primary.main} 0%, ${theme.palette.warning.main} 100%`
            ),
          }}
        >
          Let’s Build Something Thoughtful
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Button
          size="large"
          variant="contained"
          color="inherit"
          endIcon={<Iconify icon="eva:arrow-ios-forward-fill" />}
          href={paths.contact}
        >
          Start a Conversation
        </Button>
      </m.div>
    </Box>
  );

  const renderImg = (
    <Box
      alt="aboutme"
      component={m.img}
      src="/assets/undrwaimg/about.34cb49a4.png"
      variants={varFade().in}
      sx={{
        height: 1,
        width: 0.5,
        objectFit: 'cover',
        position: 'absolute',
        right: 0,
        boxShadow: `-80px 80px 80px ${
          theme.palette.mode === 'light'
            ? alpha(theme.palette.grey[500], 0.48)
            : alpha(theme.palette.common.black, 0.24)
        }`,
      }}
    />
  );

  return (
    <Box
      sx={{
        minHeight: 560,
        overflow: 'hidden',
        position: 'relative',
        ...bgGradient({
          startColor: `${theme.palette.grey[900]} 25%`,
          endColor: alpha(theme.palette.grey[900], 0),
          imgUrl: '/assets/images/myphoto/satyendra_singh.jpeg',
        }),
        ...(mdUp && {
          ...bgGradient({
            color: alpha(theme.palette.background.default, 0.9),
            imgUrl: '/assets/background/overlay_4.jpg',
          }),
        }),
      }}
    >
      <Container component={MotionViewport}>
        <Grid container>
          <Grid xs={12} md={6}>
            {renderDescription}
          </Grid>

          {mdUp && <Grid md={6}>{renderImg}</Grid>}
        </Grid>
      </Container>
    </Box>
  );
}
